// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__26WC0","file":"styles_file__3JG3G"};